import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import LockOutlineIcon from '@mui/icons-material/LockOutlined';
import { layout } from '../../themes/smartinventoryTheme';

// Role-gated routes are hidden from the nav; reaching one by URL lands here
// naming who to ask, rather than a redirect that looks like a bug.
// `title`/`description` are already-translated and already interpolated
// with `route`/`owner` by the caller (e.g. t('permission.noAccess', { route, owner })).
const PermissionState = ({ title, description, action }) => (
  <Box sx={{ textAlign: 'center', py: 5, px: 3 }}>
    <Box
      sx={{
        width: layout.stateIconSize,
        height: layout.stateIconSize,
        borderRadius: '50%',
        bgcolor: 'action.selected',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        mb: 1.5,
      }}
    >
      <LockOutlineIcon color="disabled" />
    </Box>
    <Typography variant="subtitle1">{title}</Typography>
    {description && (
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, maxWidth: 380, mx: 'auto' }}>
        {description}
      </Typography>
    )}
    {action && (
      <Box sx={{ mt: 2 }}>
        <Button variant="outlined" onClick={action.onClick}>
          {action.label}
        </Button>
      </Box>
    )}
  </Box>
);

export default PermissionState;
